import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RescheduleConfirmDialogData {
  patientName: string;
  from: string;
  to: string;
  /** False for a type that never sends; the switch is then not offered. */
  canNotify: boolean;
  /** The new slot already holds as many patients as the practice allows. */
  slotFull: boolean;
}

export interface RescheduleConfirmDialogResult {
  notifyPatient: boolean;
}

/** Confirms a booking dragged to a new slot, with the choice to tell the patient. */
@Component({
  selector: 'app-reschedule-confirm-dialog',
  templateUrl: './reschedule-confirm-dialog.component.html',
  styleUrls: ['./reschedule-confirm-dialog.component.scss']
})
export class RescheduleConfirmDialogComponent {
  notifyPatient = true;

  constructor(
    public dialogRef: MatDialogRef<RescheduleConfirmDialogComponent, RescheduleConfirmDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: RescheduleConfirmDialogData,
  ) { }

  confirm(): void {
    this.dialogRef.close({ notifyPatient: this.data.canNotify && this.notifyPatient });
  }
}
